import { Injectable } from "@angular/core";
import { HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { ComplexConfig } from "../../interfaces/complex-exercise/complex-config";
import { ComplexSubmissionItem } from "../../interfaces/complex-exercise/complex-submissions";
import {
  ComplexSubmitPayload,
  ComplexSubmitResponse,
} from "../../interfaces/complex-exercise/complex-submit";
import { BulkDownloadResponse } from "../../interfaces/exercise-file-upload-download-request";
import { Guid } from "../../types/guid";
import { ApiService } from "../api/api.service";

@Injectable({
  providedIn: "root",
})
export class ComplexExerciseApiService {
  constructor(private readonly apiService: ApiService) {}

  getComplexConfig(data: {
    courseId: Guid;
    groupId?: Guid | null;
    exerciseId: Guid;
  }): Observable<ComplexConfig> {
    const groupSegment = data.groupId ? `groups/${data.groupId}/` : "";

    return this.apiService.getRequest<ComplexConfig>(
      `courses/${data.courseId}/${groupSegment}exercises/${data.exerciseId}/complex/`,
    );
  }

  submitComplexAnswers(data: {
    courseId: Guid;
    groupId: Guid;
    exerciseId: Guid;
    payload: ComplexSubmitPayload;
  }): Observable<ComplexSubmitResponse> {
    return this.apiService.postRequest<ComplexSubmitResponse>(
      `courses/${data.courseId}/groups/${data.groupId}/exercises/${data.exerciseId}/complex/submit/`,
      data.payload,
    );
  }

  getComplexSubmissions(data: {
    courseId: Guid;
    groupId: Guid;
    exerciseId: Guid;
  }): Observable<ComplexSubmissionItem[]> {
    return this.apiService.getRequest<ComplexSubmissionItem[]>(
      `courses/${data.courseId}/groups/${data.groupId}/exercises/${data.exerciseId}/complex/submissions/`,
    );
  }

  getComplexSubmissionsCsv(data: {
    courseId: Guid;
    groupId: Guid;
    exerciseId: Guid;
  }): Observable<HttpResponse<Blob>> {
    return this.apiService.getRequestBlob(
      `courses/${data.courseId}/groups/${data.groupId}/exercises/${data.exerciseId}/complex/submissions/csv/`,
    );
  }

  getComplexBulkDownload(data: {
    courseId: Guid;
    groupId: Guid;
    exerciseId: Guid;
  }): Observable<BulkDownloadResponse> {
    return this.apiService.getRequest<BulkDownloadResponse>(
      `courses/${data.courseId}/groups/${data.groupId}/exercises/${data.exerciseId}/complex/bulk_download/`,
    );
  }
}
